import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@material-ui/core/TextField";
import {Alert, Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import isSameDay from 'date-fns/isSameDay';
import AddBoxIcon from '@material-ui/icons/AddBox';
import Checkbox from "@material-ui/core/Checkbox";
import API from "@beardeddevops/react.api"
import APPCONFIG from "../../constants/Config";
import {confirmAlert} from "react-confirm-alert";
import SignatureCanvas from "react-signature-canvas";
import moment from "moment";
import Select from "react-select";

function withCustomStyles(WrappedComponent) {
	return function StyledComponent(props) {
		// const classes = useStyles();
		return <WrappedComponent {...props}  />; //classes={classes}
	};
}

class Invoice extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Financials_Invoice._name);
		let date = new Date();
		this.sigPad = null;
		this.signatureCanvasProps = {width: 450, height: 208, className: 'sigCanvas'};
		this.state = {
			week_start_date: new Date(date.setDate(date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1) - 1)), //get this week's sunday
			base_pay: 0,
			commission: 0,
			feedback: 0,
			gas_credits: 0,
			hardware: 0,
			hardware_items: [],
			bonus: false,
			total_pay: 0,
			preview: true,
			// pkey: this.props.id,
			highlightedSundays: [], // 	new Date(2025, 7, 17), // August 17, 2025
			disableHardwareSubmit: false,
			disableInvoiceSubmit: false,
			tickets: []
		}
	}

	async fetchTickets() {
		//grab tickets for fe
		let tickets = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		tickets.filter = {
			'week_of': this.state.week_start_date
		}
		tickets = await tickets.submit(null, 'GET_TICKETS', true);
		if (tickets && tickets.items && tickets.items.length > 0) {
			this.setState({tickets: tickets.items})
		} else {
			this.setState({tickets: []})
		}
	}

	async componentDidMount() {
		await this.fetchTickets();
	}

	async componentDidUpdate(prevState, prevProps, snapshot) {
		const { location } = this.props.history;

		//handle tab change and "search"
		if(this.props.history.location.hash.includes("?pkey") && this.state.loading !== true) {
			this.setState({ loading: true });
			const queryString = this.props.history.location.hash.split('?')[1];
			const hashTab = this.props.history.location.hash.split('?')[0];
			const params = new URLSearchParams(queryString);
			const result = Object.fromEntries(params.entries());

			//set pkey and grab invoice
			this.setState({ pkey: result.pkey }, async () => {
				await this.loadSelf();
				await this.fetchTickets()
				if (this.state.hardware_items && typeof(this.state.hardware_items) === "string") {
					await this.setState({hardware_items: JSON.parse(this.state.hardware_items)});
				}
				//clear the params from the hash after setting state
				this.props.history.replace({
					...location,
					hash: hashTab
				});
			});
		}
	}

	shouldDisableDate = (date) => {
		return date.getDay() !== 0; // only allow Sundays
	};


	renderDay = (day, week_start_date, isInCurrentMonth, dayComponent) => {
		const isSunday = day.getDay() === 0;
		const isSelected = isSameDay(day, this.state.week_start_date);
		const isHighlighted = this.state.highlightedSundays.some((highlightedDate) =>
			isSameDay(day, highlightedDate)
		);

		const baseStyle = {
			borderRadius: '50%',
			width: 36,
			height: 36,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			fontSize: 14,
			transition: 'all 0.2s ease-in-out',
			cursor: isSunday && isInCurrentMonth ? 'pointer' : 'default',
		};

		const styles = {
			...baseStyle,

			// 🚫 Disable non-Sundays or dates from other months
			...(!isSunday || !isInCurrentMonth
				? {
					color: '#aaa',
					opacity: 0.5,
					pointerEvents: 'none',
				}
				: {}),

			// ✅ Highlight selected Sunday (must be in current month)
			...(isSelected && isInCurrentMonth
				? {
					backgroundColor: '#1976d2',
					color: '#fff',
				}
				: {}),

			// 🟡 Highlight special Sundays (but not selected one)
			...(isHighlighted && !isSelected
				? {
					backgroundColor: '#ffeeba',
				}
				: {}),
		};

		return (
			<div style={styles}>
				<span>{day.getDate()}</span>
			</div>
		);
	};


	updateTextField = async (event, column) => {
		const newValue = event.currentTarget.value;
		if (column === "bonus") {
			this.setState({[column]: !this.state[column]}, () => this.handleTotalUpdate());
		} else if (column === "gas_credits" || column === "feedback") {
				//dont allow decimals, only whole numbers
				if (newValue === '' || /^-?(?:\d+\.\d+|\d+|\.\d+)$/.test(newValue)) {
				this.setState({[column]: newValue}, () => newValue !== '' ? this.handleTotalUpdate() : null);
			}
		} else {
			if (newValue === '' || /^-?(?:\d+)?(?:\.\d*)?$/.test(newValue)) {
				this.setState({[column]: newValue}, () => newValue !== '' ? this.handleTotalUpdate() : null);
			}
		}
	};

	handleOnBlur = async (event, column) => {
		const newValue = event.currentTarget.value;
		if(newValue === '') {
			this.setState({[column]: 0}, () => this.handleTotalUpdate());
		}
	}

	handleDateChange = async (date) => {
		this.setState({ week_start_date: date });
		this.state.week_start_date = date;
		await this.fetchTickets();
	};

	handleRemovingBlankHardwareLines = async () => {
		//remove any that are blank, and recalc total
		const hardware_items = this.state.hardware_items.filter(row => {
			return row.total !== '' && row.description !== '';
		});
		await this.setState({ hardware_items }, () => this.handleTotalUpdate());
	}

	validateHardwareItems = async () => {
		//check if there are any items that are NOT negative and are missing a ticket
		const invalid_items = this.state.hardware_items.filter(row => {
			return row.total >= 0 && !row.ticket;
		});
		if (invalid_items.length > 0) {
			API.Toast.warn("Ticket is required unless hardware amount is negative.", {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 10000
			});
			return false;
		}

		//call api method to validate the hardware items
		if (this.state.hardware_items?.length > 0) {
			return await this.checkHardwareSums();
		} else {
			return true;
		}


	}

	checkHardwareSums = async () => {
		let hardwareItems = new API.BuildClass(Types.Tickets_Financials._name, API.RequestType.READ_ALL);
		hardwareItems.filter = {
			'hardware_items': JSON.stringify(this.state.hardware_items ?? [])
		}
		hardwareItems = await hardwareItems.submit(null, 'GET_VALIDATE_SUMS');
		if (hardwareItems && hardwareItems.length > 0) {
			for (const item of hardwareItems) {
				API.Toast.warn(item, {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 10000
				});
			}
			return false;
		}
		return true;
	}

	previewInvoice = async () => {
		//remove extras
		await this.handleRemovingBlankHardwareLines();
		//send stuff and open a new tab with PDF stuff in it
		let preview_invoice = new API.BuildClass(Types.Forms_Results._name, API.RequestType.CREATE);
		preview_invoice.object.form_results = JSON.stringify(this.state);
		await preview_invoice.submit(null, 'PUT_PREVIEW_INVOICE')

		// Open the final render page with token or no param
		let url = APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + "/forms/results/invoice";
		window.open(url, "_blank");
	}

	handleSubmit = async (event) => {
		if (this.state.disableInvoiceSubmit) {
			return;
		}
		this.setState({disableInvoiceSubmit: true})
		//send stuff to server
		let invoice_model = new API.BuildClass(Types.Financials_Invoice._name, API.RequestType.CREATE);
		await this.setState({
			signature_data: this.sigPad.getCanvas().toDataURL('image/png'),
		});
		//todo: need to remove extra hardware items lines?
		//TODO: need to check if the start date has already been used by this person
		//TODO: if pkey then post not put
		if(this.state.pkey) {
			await invoice_model.submit(this, 'POST')
		} else {
			await invoice_model.submit(this, 'PUT')
		}
		this.setState({modalSignature: false, disableInvoiceSubmit: false})
		//reroute them to the approval table here, where they can then print off the invoice if they want
		if(typeof this.props.handleTabChange === 'function'){
			this.props.handleTabChange(event, 'approvals')
		}
	}

	addHardwareLine = async () => {
		if (this.state.disableHardwareSubmit) {
			return;
		}
		this.setState({disableHardwareSubmit: true})
		//add new line with its own key stuff for hardware
		const newRow = { description: '', total: '', ticket: ''};
		this.setState((prevState) => ({
			hardware_items: [...prevState.hardware_items, newRow],
			disableHardwareSubmit: false
		}));
	}

	handleTotalUpdate = () => {
		let final_total = 0;
		//update the total
		final_total += parseFloat(this.state.base_pay);
		final_total += parseFloat(this.state.commission);
		final_total += parseFloat(this.state.feedback);
		final_total += parseFloat(this.state.gas_credits);
		let hardware = 0;
		this.state.hardware_items.forEach((row) => {
			if (/^-?\d*\.?\d*$/.test(row.total) && row.total !== '') {
				hardware += parseFloat(row.total);
			}
		})
		final_total += parseFloat(hardware);

		//handle 10% bonus (only includes base pay and commission)
		if(this.state.bonus){
			final_total += (parseFloat(this.state.base_pay) + parseFloat(this.state.commission)) * .1;
		}

		//loop through the hardware rows
		this.setState({total_pay: parseFloat(final_total).toFixed(2), hardware});
	}

	handleInputChange = (index, event, name) => {
		const updatedRows = [...this.state.hardware_items];
		if(name === 'total') {
			if (
				event.currentTarget.value === '' ||
				/^-?\d*\.?\d*$/.test(event.currentTarget.value)
			) {
				updatedRows[index][name] = event.currentTarget.value;
			}

		} else {
			updatedRows[index][name] = event.currentTarget.value;
		}
		console.log(updatedRows)
		this.setState({ hardware_items: updatedRows }, () => this.handleTotalUpdate());
	};

	handleSelectChange = (index, option, name) => {
		const updatedRows = [...this.state.hardware_items];

		// option will be null when cleared
		updatedRows[index][name] = option ? option : null;

		this.setState(
			{ hardware_items: updatedRows },
			() => this.handleTotalUpdate()
		);

		console.log('UPDATED', updatedRows)
	};


	handleDeleteRow = (index) => {
		const updatedRows = [...this.state.hardware_items];
		updatedRows.splice(index, 1);
		this.setState({ hardware_items: updatedRows }, () => this.handleTotalUpdate());
	};

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	clearSigPad = () => {
		this.sigPad.clear();
	};

	getSigPadRef = (ref) => {
		if (!ref) return;
		this.sigPad = ref;
	}

	clearSigPadRef = () => {
		confirmAlert({
			title: "Confirm Clear Signature",
			message: "Are you sure you want to clear this signature?",
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						this.clearSigPad()
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	};

	render = () => {
		const CustomPicker = withCustomStyles(DatePicker);

		const hardwareItems = Array.isArray(this.state.hardware_items) ? this.state.hardware_items : [];
		const ticketOptions = this.state.tickets.map(item => ({
			label: item.label,
			value: item.pkey,
		}));

		return (
			<div style={styles.container} className="pay-center-invoice">
				{/*TODO: put a warning here if the sunday they are doing has already been done*/}
				{this.state.pkey &&
				<Alert color={'warning'}>
					<p style={{ fontSize: '18px', marginBottom: '0px' }}>
						<span>
							<strong>
								You are editing an invoice for {moment(this.state.week_start_date).format('MM/DD/YYYY')}
							</strong>
						</span>
					</p>
				</Alert>
				}

				<Modal
					isOpen={this.state.modalSignature}
					toggle={() => this.handleToggleModal('modalSignature')}
					size={"md"}
					backdrop={true}
					title={"Approval Signature"}
				>
					<ModalHeader>
						Approval Signature
					</ModalHeader>
					<ModalBody>
						<div className="form-group">
							<b style={{textAlign: 'center'}}>I verify that this information is accurate to the best of my abilities</b>
							<div style={{backgroundColor: '#f2f3f4', border: 2}}>
								<SignatureCanvas penColor='black' canvasProps={this.signatureCanvasProps} minWidth={3} ref={this.getSigPadRef}/>
							</div>
							<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
								<Button color="danger" onClick={this.clearSigPadRef}>Clear Signature</Button>
								<Button color="secondary" onClick={() => {
									this.setState({modalSignature: false})
								}}>Cancel</Button>
								<Button color="primary" onClick={async () => await this.handleSubmit()}>Save</Button>
							</div>
						</div>
					</ModalBody>
				</Modal>

				<div className="flex">
					<div className="text-left">
						<h3>Invoice for Karls Technology</h3>
					</div>
				</div>
				<br/>
				{!this.state.pkey &&
				<div className="pay-center-invoice-toolbar">
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<CustomPicker
							label="Select Week Start Date"
							value={this.state.week_start_date}
							onChange={this.handleDateChange}
							shouldDisableDate={this.shouldDisableDate}
							renderDay={this.renderDay}
							format="MM/dd/yyyy"
							autoOk
						/>
					</MuiPickersUtilsProvider>
					<Button onMouseDown={this.previewInvoice}>
						Preview Invoice
					</Button>
				</div>
				}

				<table style={styles.table}>
					<thead>
						<tr>
							<th style={styles.th}>Description</th>
							<th style={styles.th}>Totals</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style={{width:'75%'}}>
								<input type="text" value="Completed Projects" style={styles.inputFull} readOnly />
							</td>
							<td>
								<TextField
									style={styles.inputFull}
									value={this.state.base_pay}
									onChange={(e) => this.updateTextField(e, 'base_pay')}
									onBlur={(e) => this.handleOnBlur(e, 'base_pay')}
									variant={'outlined'}
									InputProps={{
										style: {
											fontSize: '16px',
											height: '41px', // adjust this to match your input height
											border: "1px solid #0D1B3E",
											borderRadius: "0",
										},
									}}

								/>
							</td>
						</tr>
						<tr>
							<td style={{width:'75%'}}>
								<input type="text" value="Commission" style={styles.inputFull} readOnly />
							</td>
							<td>
								<TextField
									style={styles.inputFull}
									value={this.state.commission}
									onChange={(e) => this.updateTextField(e, 'commission')}
									onBlur={(e) => this.handleOnBlur(e, 'commission')}
									variant={'outlined'}
									InputProps={{
										style: {
											fontSize: '16px',
											height: '41px', // adjust this to match your input height
											border: "1px solid #0D1B3E",
											borderRadius: "0",
										},
									}}

								/>
							</td>
						</tr>
						<tr>
							<td style={{width:'75%'}}>
								<input type="text" value="Reviews" style={styles.inputFull} readOnly />
							</td>
							<td>
								<TextField
									style={styles.inputFull}
									value={this.state.feedback}
									onChange={(e) => this.updateTextField(e, 'feedback')}
									onBlur={(e) => this.handleOnBlur(e, 'feedback')}
									variant={'outlined'}
									InputProps={{
										style: {
											fontSize: '16px',
											height: '41px', // adjust this to match your input height
											border: "1px solid #0D1B3E",
											borderRadius: "0",
										},
									}}

								/>
							</td>
						</tr>
						<tr>
							<td style={{width:'75%'}}>
								<input type="text" value="Gas Credits" style={styles.inputFull} readOnly />
							</td>
							<td>
								<TextField
									style={styles.inputFull}
									value={this.state.gas_credits}
									onChange={(e) => this.updateTextField(e, 'gas_credits')}
									onBlur={(e) => this.handleOnBlur(e, 'gas_credits')}
									variant={'outlined'}
									InputProps={{
										style: {
											fontSize: '16px',
											height: '41px', // adjust this to match your input height
											border: "1px solid #0D1B3E",
											borderRadius: "0",
										},
									}}

								/>
							</td>
						</tr>
						<tr>
							<td style={styles.hardwareSummaryLabel}>
								<div style={styles.hardwareHeader}>
									<input type="text" value="Hardware" style={styles.hardwareLabelInput} readOnly />
									<Button color={'primary'} size={'sm'} onClick={async () => {
										await this.addHardwareLine()
									}} style={styles.hardwareAddButton}>
										<AddBoxIcon/>
										<span className="hidden-xs">&nbsp;Add Item</span>
									</Button>
								</div>
							</td>
							<td style={styles.totalsCell}>
								<TextField
									style={{...styles.inputFull, paddingTop: 0}}
									fullWidth
									value={this.state.hardware}
									variant={'outlined'}
									InputProps={{
										style: styles.textFieldInput,
										readOnly: true,
									}}
								/>
							</td>
						</tr>
						{hardwareItems.length > 0 &&
						<tr>
							<td colSpan={2} style={styles.hardwareItemsSection}>
								{hardwareItems.map((row, index) => (
									<div key={index} style={styles.hardwareItem}>
										<div className="row align-items-end pay-center-hardware-row">
											<div className="col-12 col-lg-4 mb-2">
												<TextField
													fullWidth
													margin="dense"
													value={row.description}
													onChange={(e) => this.handleInputChange(index, e, 'description')}
													variant={'outlined'}
													InputProps={hardwareRowInputProps}
													InputLabelProps={hardwareRowLabelProps}
													label={"Description"}
												/>
											</div>
											<div className="col-12 col-lg-4 mb-2">
												<Select
													placeholder={"Ticket"}
													value={ticketOptions.find(opt => opt.value === row.ticket?.value) || null}
													onChange={(option) =>
														this.handleSelectChange(index, option, 'ticket')
													}
													options={ticketOptions}
													isClearable
													styles={hardwareSelectStyles}
												/>
											</div>
											<div className="col-6 col-lg-2 mb-2">
												<TextField
													fullWidth
													margin="dense"
													value={row.total}
													onChange={(e) => this.handleInputChange(index, e, 'total')}
													variant={'outlined'}
													InputProps={hardwareRowInputProps}
													InputLabelProps={hardwareRowLabelProps}
													label={"Total"}
												/>
											</div>
											<div className="col-6 col-lg-2 mb-2 d-flex align-items-center justify-content-end">
												<Button color={'danger'} onClick={() => this.handleDeleteRow(index)}>
													Delete
												</Button>
											</div>
										</div>
									</div>
								))}
							</td>
						</tr>
						}
						<tr>
							<td style={{width:'75%'}}>
								<input type="text" value="10% Bonus" style={styles.inputFull} readOnly />
							</td>
							<td>
								<Checkbox
									style={styles.inputFull}
									value={this.state.bonus}
									checked={this.state.bonus}
									onChange={(e) => this.updateTextField(e, 'bonus')}
									variant={'outlined'}
									InputProps={{
										style: {
											fontSize: '16px',
											height: '41px', // adjust this to match your input height
											border: "1px solid #0D1B3E",
											borderRadius: "0",
										},
									}}

								/>
							</td>
						</tr>

						<tr>
							<td style={{width:'75%'}}>
								<input type="text" value="Total" style={styles.inputFull} readOnly />
							</td>
							<td>
								<TextField
									style={styles.inputFull}
									value={this.state.total_pay}
									onChange={(e) => this.updateTextField(e, 'total_pay')}
									variant={'outlined'}
									InputProps={{
										style: {
											fontSize: '16px',
											height: '41px', // adjust this to match your input height
											border: "1px solid #0D1B3E",
											borderRadius: "0",
										},
									}}

								/>
							</td>
						</tr>
					</tbody>
				</table>
				<div className={'d-flex justify-content-end'}>
					<Button color="primary" onClick={async () => {
						await this.handleRemovingBlankHardwareLines();
						if (await this.validateHardwareItems() !== true) return;
						this.handleToggleModal('modalSignature')
					}}>
						Submit
					</Button>
				</div>
			</div>
		);
	}
}

const styles = {
	container: {
		fontFamily: 'Arial, sans-serif',
		padding: '20px',
		margin: 'auto',
		width: '100%',
		maxWidth: '960px',
		boxSizing: 'border-box',
	},
	inputFull: {
		width: '100%',
		padding: '8px',
		fontSize: '14px',
		marginBottom: '5px'
	},
	textFieldInput: {
		fontSize: '16px',
		height: '41px',
		border: '1px solid #0D1B3E',
		borderRadius: '0',
	},
	table: {
		width: '100%',
		marginTop: '20px',
		tableLayout: 'fixed',
	},
	th: {
		backgroundColor: '#0D1B3E',
		color: 'white',
		padding: '10px'
	},
	hardwareSummaryLabel: {
		width: '75%',
		verticalAlign: 'middle',
	},
	totalsCell: {
		verticalAlign: 'top',
	},
	hardwareHeader: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		paddingBottom: '5px'
	},
	hardwareLabelInput: {
		flex: '1 1 auto',
		width: '100%',
		minWidth: 0,
		padding: '8px',
		fontSize: '14px',
		marginBottom: '5px',
	},
	hardwareAddButton: {
		flexShrink: 0,
		whiteSpace: 'nowrap',
	},
	hardwareItemsSection: {
		padding: '8px 10px 12px',
		borderTop: 'none',
	},
	hardwareItem: {
		padding: '12px',
		marginBottom: '10px',
		backgroundColor: '#f8f9fa',
		border: '1px solid #dee2e6',
		borderRadius: '4px',
	},
};

const hardwareRowLabelProps = {
	style: {
		backgroundColor: '#f8f9fa',
		padding: '0 4px',
	},
};

const hardwareRowInputProps = {
	style: {
		fontSize: '16px',
	},
};

const hardwareSelectStyles = {
	container: (base) => ({
		...base,
		width: '100%',
	}),
	control: (base) => ({
		...base,
		minHeight: '41px',
		fontSize: '16px',
		borderColor: '#0D1B3E',
		borderRadius: '0',
	}),
	menu: (base) => ({
		...base,
		zIndex: 5,
	}),
};

export default Framework.Components.withRootState(Invoice);